import { Config } from '@/config';
import { ApiService } from '@/services/api.service';

class TaskStatusesService {
  getTaskStatuses() {
    return ApiService.get(`${Config.api.document.url}api/v1/task-statuses`).then((response) => response.data);
  }
}

export const taskStatusesService = new TaskStatusesService();
